"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _agent = require("@deosite/agent");
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
var _mapProductDataNew = _interopRequireDefault(require("@deosite/helpers/mapProductDataNew"));
var productWithVariant = function productWithVariant(products, sku) {
  var product = products.find(function (product) {
    return product.sku === sku;
  });
  product.otherVariants = products.filter(function (product) {
    return product.sku !== sku;
  });
  return product;
};
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(sku, url, lang) {
    var productFamily, product, invalidProduct;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!url) {
              _context.next = 6;
              break;
            }
            _context.next = 3;
            return _agent.requests.get(url, true,
            //global.__appConfig__.elasticEnabled,
            null, lang);
          case 3:
            _context.t0 = _context.sent;
            _context.next = 9;
            break;
          case 6:
            _context.next = 8;
            return _agent.requests.get((0, _createParametrizedUrl["default"])(global.__appConfig__.productFamilyUrl, {
              sku: encodeURI(sku)
            }), true,
            //global.__appConfig__.elasticEnabled,
            null, lang);
          case 8:
            _context.t0 = _context.sent;
          case 9:
            productFamily = _context.t0;
            invalidProduct = function invalidProduct(productFamily) {
              return Object.keys(productFamily).length === 0 && productFamily.constructor === Object || (productFamily === null || productFamily === void 0 ? void 0 : productFamily.length) !== undefined;
            };
            product = invalidProduct(productFamily) ? {} : productWithVariant((0, _mapProductDataNew["default"])(productFamily), url ? productFamily.sku : sku);
            if (!(Object.keys(product).length === 0)) {
              _context.next = 15;
              break;
            }
            console.log("Error productFamily  sku: ".concat(sku, ", url: ").concat(url, ", lang: ").concat(lang.language, ", domain: ").concat(lang.domain, ", host: ").concat(lang.host));
            return _context.abrupt("return", {
              product: null,
              error: {
                statusCode: 404
              },
              categoryId: 0
            });
          case 15:
            return _context.abrupt("return", {
              product: product,
              categoryId: product.categoryId !== undefined ? product.categoryId : 0
            });
          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;